var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuffuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 66,
    viewBox: "0 0 70 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.329 30.0715V28.6692C69.329 29.1366 69.329 29.604 69.329 30.0715ZM48.764 41.913V42.2246C48.4524 44.2501 47.6734 45.8082 46.8945 46.7431C46.2713 47.5221 45.0249 48.1454 43.3112 48.6128C41.4416 49.236 37.8583 50.1709 31.6265 49.8593C26.3294 49.5477 26.641 49.7035 25.3947 49.236C23.8367 48.6128 23.3693 47.5221 22.5904 46.7431C21.6556 45.8082 21.0324 44.2501 20.7208 42.2246C20.7208 42.0688 20.7208 42.0688 20.7208 41.913L19.786 30.0715H0C0 36.3039 0.467385 41.7572 1.24636 46.1198C2.18114 50.9499 3.89489 54.6894 6.38761 57.6497C8.88034 60.6101 12.4636 62.6357 16.9817 64.0379C21.4998 65.2844 27.42 65.9076 34.5866 65.9076C41.7532 65.9076 47.6734 65.2844 52.1915 64.0379C56.7096 62.7915 60.2929 60.6101 62.7856 57.6497C65.2783 54.6894 66.9921 50.7941 67.9269 46.1198C68.7058 41.7572 69.1732 36.3039 69.329 30.0715H49.8546L48.764 41.913ZM0 30.0715C0 29.604 0 29.1366 0 28.6692V30.0715Z",
    fill: "#FE531F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8405 21.8133C17.8635 21.8133 22.7462 16.9302 22.7462 10.9067C22.7462 4.88308 17.8635 0 11.8405 0C5.81746 0 0.934814 4.88308 0.934814 10.9067C0.934814 16.9302 5.81746 21.8133 11.8405 21.8133Z",
    fill: "#FE531F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1518 21.8133C61.1748 21.8133 66.0575 16.9302 66.0575 10.9067C66.0575 4.88308 61.1748 0 55.1518 0C49.1287 0 44.2461 4.88308 44.2461 10.9067C44.2461 16.9302 49.1287 21.8133 55.1518 21.8133Z",
    fill: "#FE531F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuffuIcon);
export default __webpack_public_path__ + "static/media/puffuIcon.42f9b833d544b1e8ed79783f0afaeaba.svg";
export { ForwardRef as ReactComponent };